import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  RequeteFormatageTexte,
  RequeteVerificationLien,
  ResultatFormatageTexteEntite,
  ResultatVerificationLienEntite
} from '../entites/lien';
import { BaseService } from './base.service';
import { ReponseBase } from './reponse-base';

@Injectable({ providedIn: 'root' })
export class LienService extends BaseService {
  private readonly verifierUrl = environment.apiBaseUrl + 'lien/verifier';
  private readonly formaterTexteUrl = environment.apiBaseUrl + 'lien/formater';

  constructor(
    public http: HttpClient,
    public router: Router,
    public messageService: MessageService
  ) {
    super(messageService, router);
  }

  public VerifierLien(requete: RequeteVerificationLien): Observable<HttpResponse<ReponseBase<ResultatVerificationLienEntite>>> {
    return this.http.post<ReponseBase<ResultatVerificationLienEntite>>(
      this.verifierUrl,
      requete,
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), observe: 'response' }
    );
  }

  public FormaterTexte(requete: RequeteFormatageTexte): Observable<HttpResponse<ReponseBase<ResultatFormatageTexteEntite>>> {
    return this.http.post<ReponseBase<ResultatFormatageTexteEntite>>(
      this.formaterTexteUrl,
      requete,
      { headers: new HttpHeaders({ 'Content-Type': 'application/json' }), observe: 'response' }
    );
  }
}
